import React from 'react';

const TableElement = ({
  element,
  isEditor = false,
  updateCell = null
}) => {
  const { content = {} } = element;
  const rows = Array.isArray(content.rows) && content.rows.length > 0
    ? content.rows
    : [[{ text: '' }, { text: '' }], [{ text: '' }, { text: '' }]];

  const borderColor = content.borderColor || '#2A4D25';
  const borderWidth = content.borderWidth ?? 1;
  const headerRow = Boolean(content.headerRow);
  const headerBg = content.headerBg || '#2A4D25';
  const headerColor = content.headerColor || '#ffffff';
  const cellBg = content.cellBg || '#ffffff';
  const textColor = content.textColor || '#1f2937';
  const fontSize = content.fontSize || 16;
  const fontFamily = content.fontFamily || 'Inter';

  const handleCellChange = (rowIdx, colIdx, value) => {
    if (!updateCell) return;
    const nextRows = rows.map((row, r) =>
      row.map((cell, c) =>
        r === rowIdx && c === colIdx ? { ...cell, text: value } : cell
      )
    );
    updateCell(nextRows);
  };

  return (
    <div className="w-full h-full" style={{ overflow: 'hidden' }}>
      <table
        className="w-full h-full"
        style={{
          borderCollapse: 'collapse',
          tableLayout: 'fixed',
          fontSize: `${fontSize}px`,
          color: textColor,
          fontFamily
        }}
      >
        <tbody>
          {rows.map((row, rIdx) => {
            const isHeader = headerRow && rIdx === 0;
            return (
              <tr key={rIdx}>
                {row.map((cell, cIdx) => (
                  <td
                    key={cIdx}
                    style={{
                      border: `${borderWidth}px solid ${borderColor}`,
                      background: isHeader ? headerBg : cellBg,
                      color: isHeader ? headerColor : textColor,
                      fontWeight: isHeader ? 600 : 400,
                      padding: '6px 8px',
                      verticalAlign: 'middle',
                      textAlign: 'center'
                    }}
                  >
                    {isEditor && updateCell ? (
                      <input
                        type="text"
                        value={cell?.text || ''}
                        onChange={(e) => handleCellChange(rIdx, cIdx, e.target.value)}
                        onMouseDown={(e) => e.stopPropagation()}
                        onClick={(e) => e.stopPropagation()}
                        style={{
                          width: '100%',
                          background: 'transparent',
                          color: 'inherit',
                          fontSize: 'inherit',
                          fontWeight: 'inherit',
                          textAlign: 'center',
                          border: 'none',
                          outline: 'none'
                        }}
                      />
                    ) : (
                      <span>{cell?.text || ''}</span>
                    )}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default TableElement;
